import React from 'react';

import {OdontoNearestDateProfessionalListProps} from './types';
import {useOdontoNearestDateProfessionalList} from './hooks/useOdontoNearestDateProfessionalList';
import {BookingLoadingState} from 'presentation/modules/booking/shared/ui/components/BookingLoadingState';
import {BookingErrorState} from 'presentation/modules/booking/shared/ui/components/BookingErrorState';
import {OdontoProfessionalSelectionNotFoundState} from '../OdontoProfessionalSelectionNotFoundState';
import {FinishWithoutCompleteFlowEnum} from 'main/analytics/gaTagsEnum';
import {translations} from 'presentation/translations-new';
import {ProfessionalDateList} from 'presentation/modules/booking/shared/ui/components/ProfessionalSelection/ProfessionalDateList';
import {ProfessionalDateSection} from 'presentation/modules/booking/shared/ui/components/ProfessionalSelection/ProfessionalDateSection';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';

const {bookOdonto} = translations['pt-br'].privateFlow.services;
const {loadingState, loadingError} = translations['pt-br'].privateFlow.bookingFlow.professionalFlow;

export function OdontoNearestDateProfessionalList({
	handleSelectHour,
	handleClearShiftAndSearch,
	availableDates,
}: OdontoNearestDateProfessionalListProps) {
	const {
		isLoading,
		isError,
		odontoMultiAvailableTimesRefetch,
		showNotFoundState,
		odontoMultiAvailableTimesFiltered,
		query,
	} = useOdontoNearestDateProfessionalList({availableDates});

	if (isLoading) {
		return (
			<BookingLoadingState
				showHeader={false}
				pageTitle={bookOdonto}
				loadingText={loadingState}
			/>
		);
	}

	if (isError) {
		return (
			<BookingErrorState
				showHeader={false}
				pageTitle={bookOdonto}
				errorTitle={loadingError}
				handleRefresh={odontoMultiAvailableTimesRefetch}
			/>
		);
	}

	if (showNotFoundState) {
		return (
			<OdontoProfessionalSelectionNotFoundState
				dataTagId={FinishWithoutCompleteFlowEnum.SEM_HORARIOS_AGENDAMENTO_DISPONIVEL}
				showClearFilterButton
				handleClearShiftAndSearch={() => {
					handleClearShiftAndSearch();
				}}
			/>
		);
	}
	return (
		<ProfessionalDateList>
			{odontoMultiAvailableTimesFiltered?.map(timesByDate => {
				if (timesByDate.times.length === 0) return null;

				return (
					<ProfessionalDateSection
						key={timesByDate.date}
						date={timesByDate.date}
						professionals={timesByDate.times}
						onSelectHour={handleSelectHour}
						flowType={FlowEnum.ODONTO}
						query={query}
					/>
				);
			})}
		</ProfessionalDateList>
	);
}
